import { IAppReducer } from 'models';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Images } from '../../../assets/images/images.index';

const providersProcessor = (customerStripeId: string) => {
  return {
    stripe: {
      url: `https://dashboard.stripe.com/customers/${customerStripeId}`,
      img: Images.stripe,
      alt: 'Stripe Dashboard',
    },
    dlocal: {
      url: 'https://dashboard.dlocal.com',
      img: Images.dlocal,
      alt: 'DLocal Dashboard',
    },
    cash: {
      url: null,
      img: Images.cash,
      alt: 'Cash Dashboard',
    },
    'ath movil': {
      url: null,
      img: Images.ath_movil,
      alt: 'Ath Movil Dashboard',
    },
  };
};

type ProviderKey = 'stripe' | 'dlocal' | 'cash' | 'ath movil';

export const PaymentGatewayLink = ({
  providerProcessor,
  customerStripeId,
}: {
  providerProcessor: string;
  customerStripeId: string;
}) => {
  const user = useSelector((state: IAppReducer) => state.authReducer);

  const paymentData = useMemo(() => {
    if (!user?.agentId) return null;

    const providerProcessorLowerCase =
      providerProcessor?.toLowerCase() as string;

    if (
      !['stripe', 'dlocal', 'cash', 'ath movil'].includes(
        providerProcessorLowerCase
      )
    ) {
      return null;
    }

    const provider =
      providersProcessor(customerStripeId)[
        providerProcessorLowerCase as ProviderKey
      ];
    if (!provider) return null;

    return provider;
  }, [providerProcessor, customerStripeId, user?.agentId]);

  if (!paymentData) return null;

  return (
    <a href={paymentData.url || '#'} target="_blank" rel="noopener noreferrer">
      <img src={paymentData.img} alt={paymentData.alt} />
    </a>
  );
};
